<template>
  <Icon
    name="show"
    :width="20.451"
    :height="13.944"
  >
    <path
      :fill="fill"
      d="M10.225,89.25A10.952,10.952,0,0,0,0,96.222a10.984,10.984,0,0,0,20.451,0A10.952,10.952,0,0,0,10.225,89.25Zm0,11.62a4.648,4.648,0,1,1,4.648-4.648A4.6,4.6,0,0,1,10.225,100.87Zm0-7.437a2.789,2.789,0,1,0,2.789,2.789A2.739,2.739,0,0,0,10.225,93.433Z"
      transform="translate(0 -89.25)"
    />
  </Icon>
</template>

<script>
import iconMixin from "./iconMixin";

export default {
  name: 'Show',
  mixins: [iconMixin]
}
</script>